import React, { useEffect, useState } from "react";
import { useAuth } from "../../../context/AuthContext";
import {
  getEngineerReportRequests,
  updateEngineerReportRequest,
  EngineerReportRequest,
} from "../../../hooks/serviceMySpaceEngineer";
import { useNavigate } from "react-router-dom";
import {
  NotificationCard,
  NotificationHeader,
  NotificationBody,
  NotificationList,
} from "../../../components/notificationCard"; // Supondo que você tenha componentes semelhantes para relatórios
import { Button, Title } from "./style";
import { useTranslation } from "react-i18next";

const EngineerReportRequests: React.FC = () => {
  const [requests, setRequests] = useState<EngineerReportRequest[]>([]);
  const { axiosConfig } = useAuth();
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    const fetchRequests = async () => {
      try {
        const data = await getEngineerReportRequests(axiosConfig)();
        const array = Object.values(data);
        setRequests(array);
      } catch (error) {
        alert(error);
        setError("Falha ao carregar solicitações");
      } finally {
        setLoading(false);
      }
    };

    fetchRequests();
  }, [axiosConfig]);

  const handleResponse = async (
    id: number,
    decision: "accepted" | "denied"
  ) => {
    try {
      await updateEngineerReportRequest(axiosConfig)(id, decision); // Usando a nova função
      setRequests((prev) =>
        prev.map((request) =>
          request.id === id ? { ...request, status: decision } : request
        )
      );
    } catch (error) {
      console.error("Falha ao atualizar o status da solicitação:", error);
    }
  };
  if (loading) return <div>{t("loading")}</div>;
  if (error) return <div>{error}</div>;

  function getStatus(status: string) {
    switch (status) {
      case "accepted":
        return "Aceito";
      case "denied":
        return "Rejeitado";
      case "manual_assigned":
        return "Atribuido manualmente";
      default:
        return "Pendente";
    }
  }

  return (
    <div>
      {requests.length === 0 ? (
        <p>Você não possui solicitações de visitas!</p>
      ) : (
        <NotificationList>
          {requests.map((request) => {
            let bg_status = "!border-[#FF0000] bg-[#FF7575]";
            let text = "!text-white";

            if (request.status == "accepted") {
              bg_status = "!border-[#50700F] bg-[#E1E7D6]";
              text = "!text-[#50700F]";
            } else if (request.status == "archived") {
              bg_status = "!border-gray-700 bg-gray-300";
              text = "!text-gray-700";
            } else if (
              request.status !== "denied" &&
              request.status !== "rejected"
            ) {
              bg_status = "!border-[#D96900] bg-[#F6C112]";
              text = "!text-white";
            }

            return (
              <li key={request.id}>
                <NotificationCard>
                  <NotificationBody>
                    <p className="text-2xl">
                      <strong>Propriedade:</strong> {request.property.name}
                    </p>
                    <p className="text-md !mt-1">
                      <strong>Cidade:</strong> {request.property.city} -{" "}
                      {request.property.federal_unity}
                    </p>

                    <div
                      className={`flex flex-rol justify-around items-center ${text} !border-1 ${bg_status} rounded-[5px] w-fit px-2 py-1 mt-4`}
                    >
                      {getStatus(request.status)}
                    </div>
                  </NotificationBody>
                  {request.status === "pending" ||
                  request.status === "manual_assigned" ? (
                    <div className="flex items-center">
                      <Button
                        style={{ margin: "10px", backgroundColor: "#658C39" }}
                        onClick={() => handleResponse(request.id, "accepted")}
                      >
                        Aceitar
                      </Button>
                      <Button
                        style={{ margin: "10px", backgroundColor: "#FF0000" }}
                        onClick={() => handleResponse(request.id, "denied")}
                      >
                        Negar
                      </Button>
                    </div>
                  ) : (
                    <div></div>
                  )}
                  {request.status == "accepted" && (
                    <div className="flex items-center gap-10">
                      <Button
                        className="!bg-[#658C39]"
                        onClick={() =>
                          window.open(`/docs/laudo-orientacoes.pdf`, "_blank")
                        }
                      >
                        Orientações para o laudo
                      </Button>
                      <Button
                        onClick={() =>
                          navigate(
                            `/detailsPropertySeller/${request.property_id}`
                          )
                        }
                      >
                        Ir para a propriedade
                      </Button>
                    </div>
                  )}
                </NotificationCard>
              </li>
            );
          })}
        </NotificationList>
      )}
    </div>
  );
};

export default EngineerReportRequests;
